import { Link } from 'react-router-dom';
import { guides } from '@/mocks/guides';

export default function FeaturedGuides() {
  return (
    <section id="guides" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-10">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-accent-300/60 bg-accent-50 mb-4">
              <span className="text-xs font-semibold text-accent-700">Featured Guides</span>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              Learn &amp; Master Spreadsheets
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-xs">
            Expert-written guides to help you build, optimize, and maintain your spreadsheet workflows
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {guides.map((guide) => (
            <Link
              key={guide.slug}
              to={guide.slug}
              className="group block rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:border-primary-300/60 hover:shadow-sm transition-all duration-200 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={guide.imageUrl}
                  alt={guide.title}
                  title={guide.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/50"></div>
                <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full text-xs font-semibold bg-background-50/90 text-foreground-700">
                  {guide.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {guide.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {guide.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/article/what-is-litbuy-spreadsheet"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-primary-600 border-2 border-primary-500 rounded-full hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            View All Guides
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}